import { render } from "./NotificationIcon.vue?vue&type=template&id=40054a14&ts=true"
import script from "./NotificationIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/NotificationIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40054a14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40054a14', __exports__)) {
    api.reload('40054a14', __exports__)
  }
  
  module.hot.accept("./NotificationIcon.vue?vue&type=template&id=40054a14&ts=true", () => {
    api.rerender('40054a14', render)
  })

}


export default __exports__